<template>
  <div class="loyalty-area" href="/pages/members">
    <h3 class="heading">{{ heading }}</h3>
    <a href="/pages/members"><Picture :images="images" class="image" /></a>
    <div class="text-block">
      <p class="text">
        Rat & Boa loyalty programme - our world of unique rewards and bespoke
        benefits. Create an account now and you'll get early access to sales and
        new collections, and we'll give you {{ bonus }} to spend on your first
        order.
      </p>
      <ul class="link-list">
        <li class="link-item">
          <Button transparent @click="setSlideSignUp(true)">
            Sign up to get involved
          </Button>
        </li>
        <li class="link-item">
          <Button transparent @click="setSlideLogin(true)">
            Log in to your account
          </Button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import Button from "@/components/Button.vue";
import { mapActions, mapGetters } from "vuex";
import { signUpBonus } from "@/config";

export default {
  name: "LoyaltyArea",
  components: {
    Picture,
    Button,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    images: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }

      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.loyalty-area {
  background: rgb(248, 246, 242);
  padding: 60px 0 0;

  @include respond-above(md) {
    padding: 80px 0 0;
  }

  .text {
    font-family: $heading-font-family;
    font-size: 14px;
    margin: 0 0 15px 0;
    text-align: center;
    @include respond-above(md) {
      font-size: 18px;
      margin: 0 auto 20px;
      max-width: 620px;
    }
  }
}

.heading {
  font-size: 30px;
  font-weight: normal;
  margin: 0 0 -19px 0;
  text-align: center;
  text-transform: uppercase;
  position: relative;
  z-index: 1;

  @include respond-above(md) {
    font-size: 90px;
    margin: 0 0 -60px 0;
  }
}

.link-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.link-item {
  &:last-of-type {
    text-align: right;
  }

  @include respond-above(md) {
    margin: 0 15px 0 0;
    text-align: right;

    &:last-of-type {
      margin: 0 0 0 15px;
      text-align: left;
    }
  }
}

.link {
  color: rgb(7, 7, 7);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.49px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;

  @include respond-above(md) {
    font-size: 10px;
  }
}

.text-block {
  background: rgb(248, 246, 242);
  padding: 15px 20px 60px;

  @include respond-above(md) {
    padding: 30px 20px 80px;
  }
}
</style>
